import { supabase } from './supabaseClient.js';
import { logError } from '../lib/utils.js';

class ContratacionesService {
  static async getContrataciones(filters = {}) {
    try {
      let query = supabase
        .from('contrataciones')
        .select(`
          *,
          cotizaciones(fecha, resumen, planes(uf_base, capital_uf)),
          actividades(nombre, factor_riesgo)
        `);

      // Aplicar filtros de fecha si se proporcionan
      if (filters.fechaInicio) {
        query = query.gte('created_at', filters.fechaInicio);
      }
      if (filters.fechaFin) {
        query = query.lte('created_at', filters.fechaFin);
      }
      
      // Filtrar solo contrataciones activas por defecto
      if (filters.estado) {
        query = query.eq('estado', filters.estado);
      }

      const { data, error } = await query.order('created_at', { ascending: false });

      if (error) {
        logError('Error al obtener contrataciones:', error, { ignoreAbort: true });
        throw error;
      }

      return data || [];
    } catch (error) {
      logError('Error en getContrataciones:', error, { ignoreAbort: true });
      throw error;
    }
  }

  // Método para obtener estadísticas de contrataciones con órdenes de pago
  static async getEstadisticas(filters = {}) {
    try {
      const contrataciones = await this.getContrataciones(filters);
      
      // Obtener órdenes de pago para las contrataciones
      const contratacionIds = contrataciones.map(c => c.id);
      let ordenesPago = [];
      
      if (contratacionIds.length > 0) {
        const { data: ordenesData } = await supabase
          .from('ordenes_pago')
          .select('*')
          .in('contratacion_id', contratacionIds);
        ordenesPago = ordenesData || [];
      }
      
      // Agrupar por fecha y calcular estadísticas
      const groupedData = contrataciones.reduce((acc, contratacion) => {
        const fecha = new Date(contratacion.created_at).toISOString().split('T')[0];
        
        // Buscar órdenes de pago relacionadas
        const ordenesRelacionadas = ordenesPago.filter(op => op.contratacion_id === contratacion.id);
        const montoTotal = ordenesRelacionadas.reduce((sum, orden) => sum + (parseFloat(orden.monto) || 0), 0);
        
        // Si no hay órdenes de pago, usar el uf_base del plan de la cotización
        const montoEstimado = montoTotal > 0 ? montoTotal : (contratacion.cotizaciones?.planes?.uf_base || 0);
        
        if (!acc[fecha]) {
          acc[fecha] = { fecha, total_monto: 0, count: 0 };
        }
        
        acc[fecha].total_monto += montoEstimado;
        acc[fecha].count += 1;
        
        return acc;
      }, {});
      
      return Object.values(groupedData)
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
    } catch (error) {
      logError('Error en getEstadisticas:', error, { ignoreAbort: true });
      throw error;
    }
  }
}

export default ContratacionesService;
